"use strict";

var Notify = {
  onload: document.addEventListener('DOMContentLoaded', function () {
    Notify.init();
  }),
  init: function init() {
    this.bind();
  },
  bind: function bind() {
    var _this = this;
    $(document).on('click', '.successful-notification', function (event) {
      event.preventDefault();
      _this.successfulNotification('test text');
    }).on('click', '.danger-notification', function (event) {
      event.preventDefault();
      _this.dangerNotification('test text');
    }).on('click', '.notification__close', function (event) {
      event.preventDefault();
      event.target.parentElement.classList.remove('active');
      setTimeout(function () {
        event.target.parentElement.remove();
      }, 1000);
    });
  },
  successfulNotification: function successfulNotification(text) {
    var notify = document.createElement('div');
    notify.classList.add('notification__item');
    notify.innerHTML = "\n            <img src=\"/images/icon/IconN.png\" alt=\"icon\" class=\"notification__img\">\n            <span class=\"notification__text\">".concat(text, "</span>\n            <div class=\"notification__close\"></div>");
    $('.notification__items').append(notify);
    setTimeout(function () {
      notify.classList.add('active');
    }, 100);
    setTimeout(function () {
      notify.classList.remove('active');
      setTimeout(function () {
        notify.remove();
      }, 6000);
    }, 5000);
  },
  dangerNotification: function dangerNotification(text) {
    var notify = document.createElement('div');
    notify.classList.add('notification__item');
    notify.innerHTML = "\n            <img src=\"/images/icon/IconN.png\" alt=\"icon\" class=\"notification__img\">\n            <span class=\"notification__text\">".concat(text, "</span>\n            <div class=\"notification__close\"></div>");
    $('.notification__items').append(notify);
    setTimeout(function () {
      notify.classList.add('active');
    }, 100);
    setTimeout(function () {
      notify.classList.remove('active');
      setTimeout(function () {
        notify.remove();
      }, 6000);
    }, 5000);
  }
};